/*
  Lucien aperçu lettres — 2e visuel sur mobile (écran tactile) :
  toucher l'image affiche la 2e image, retoucher revient à la 1re (comme dans la pop-up coffret).
  Sur ordinateur, le survol est géré en CSS.
*/
(function () {
  const touchQuery = window.matchMedia('(hover: none)');

  function init(root) {
    (root || document).querySelectorAll('[data-lucien-letters-preview] [data-llp-flip]').forEach((media) => {
      if (media.dataset.llpReady === 'true') return;
      media.dataset.llpReady = 'true';
      media.addEventListener('click', () => {
        if (!touchQuery.matches) return;
        media.classList.toggle('is-flipped');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
